module.exports = {
  config: {
    contactEmail: 'hello@constantinchirila.com'
  }
}